module.exports = __webpack_public_path__ + "img/ef1-25_66.prt.9a785409.jpg";